/// <amd-module name="Reporting/Visuals/VisualMessages/StakeholderAccessRestrictedMessage" />
import * as React from "react";
import * as Resources from "Reporting/Visuals/Resources";
import { AccessRestrictedImage } from "Reporting/Visuals/VisualMessages/AccessRestrictedImage";
import { VssComponent } from "VSS/Platform/Layout";
import { Link } from "VSSUI/Link";

/** Used for Rendering "Analytics Fault-in" Experiences for visuals. */
export class StakeholderAccessRestrictedMessage extends VssComponent<{}, {}> {
    public render(): JSX.Element {
        return (
            <div className={"access-not-supported-dialog-content inline-flex-row"}>
                <span className="flex-self-center">
                    <AccessRestrictedImage />
                </span>
                <div className="flex-self-center separate-child-elements">
                    <div className="fontWeightSemiBold">{Resources.Stakeholder_DialogSubHeading}</div>
                    <div>{Resources.Stakeholder_DialogMessageText}</div>
                    <Link href="https://go.microsoft.com/fwlink/?LinkID=787012">{Resources.Stakeholder_LinkText}</Link>
                </div>
            </div>
        );
    }
}
